<template>
  <el-select
    v-model="dataValue"
    multiple=""
    style="width: 100%;"
    placeholder="请选择质量证书">
    <el-option
      v-for="item in list"
      :key="item.certId"
      :label="item.certName"
      :value="item.certId">
    </el-option>
  </el-select>
</template>
<script>
import Commom from '@/service/common'
export default {
  name: 'ProductCertificateSelect',
  props: {
    value: { type: Array, default: () => [] },
    options: { type: Object, default: () => ({}) }
  },
  data() {
    return { list: [], loading: false }
  },
  computed: {
    dataValue: {
      get: function() {
        return this.value
      },
      set: function(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    fetchList() {
      this.loading = true
      Commom.getcertificates({ pageNum: 1, pageSize: 100, certLevel: 1, ...this.options })
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if ([0, 13].includes(result)) {
            this.loading = false
            this.total = total
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
